// 引入api
import { fun_PostAction } from "@/api";
export default {
  data() {
    return {
      // 步骤条点击
      active: 0,
      // 评审流程  步骤条
      flowpath: [],
      // 委托代理协议 基本信息
      basicinformation: {
        // 项目名称
        projectName:
          "走马岭园区配套基础设施项目心苑路（食品一路至汉丹北路）施工招标",
        // 招标代理名称
        AgentName: "湖北扬子江项目管理有限公司",
        // 招标登记编号
        registerNumber: "20210402130010046",
        // 招标人名称
        bidsName: "武汉市住房和城乡建设局"
      },
      form: null,
      // 表格基础数据
      tableColumns: [
        {
          label: "投标单位名称",
          prop: "username",
          isShow: true
        },
        {
          label: "上传标书时间",
          prop: "realName"
        },
        {
          label: "投标报价",
          prop: "department"
        },
        {
          label: "是否缴纳保证金",
          prop: "roleCode"
        }
      ],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      // 文件名称
      pathName: null,
      // 组件路径
      rendertpl: null,
      // 传给子页面的值
      types: null,
      sonId: null
    };
  },
  // 模板编译完成
  mounted() {
    this.fun_GetDetails();
  },
  // 自定义方法
  methods: {
    /**
     * 切换右侧页面
     * @author 滕威
     */
    fun_ChangePage(e) {
      // if (e.processSort > this.active) {
      //   return;
      // }
      var suffix = "";
      // 判断是否有值
      if (e.sonId) {
        // 页面显示详情
        this.types = "details";
        this.sonId = e.sonId;
        suffix = "/details";
      } else {
        // 页面显示添加
        this.types = "add";
        this.sonId = "";
      }
      // 点击切换页面
      this.rendertpl = this.loadertpl(e.pathName, suffix);
    },
    /**
     * 加载本地文件
     * @author 滕威
     */
    loadertpl(pathName, suffix) {
      return function(resolve) {
        require(["../../" + pathName + suffix + "/index.vue"], resolve).default;
      };
    },
    /**
     * 获取项目信息
     * @author 付翔
     */
    async fun_GetDetails() {
      let res = await fun_PostAction(
        "/projectProcess/detail?id=" + this.$route.query.id
      );
      // 解构res.data
      const { result, data, msg } = res.data;
      // 判断请求是否成功
      if (result) {
        // 回显详情
        this.form = data.projectProcess;
        // 流程
        this.flowpath = data.purchaseProcessStepList;
        // 获取进度
        var index = 0;
        // 循环流程
        this.flowpath.forEach((value, index1) => {
          // 找出最新步骤的下标
          if (Number(data.projectProcess.processSort) >= value.processSort) {
            // 赋值
            index = index1;
          }
        });
        // 项目走到的进度
        this.active = index + 1;
        // 默认显示第一个进度的页面
        this.pathName = this.flowpath[0].pathName;
        this.fun_ChangePage(this.flowpath[0]);
        // 获取人员一览
      } else {
        // 提示请求失败消息
        this.$message.error(msg);
      }
    },
    /**
     * @description 返回
     * @author 滕威
     */
    fun_Back() {
      // 返回上一页
      this.$router.back();
    }
  }
};
